
// import { Dates } from '../../packages/dates';
// import EpgPersistence from '../../AAF/Nepg/EpgPersistence';
import EpgConstants from '../../AAF/Nepg/EpgConstants';
import RecordingLocalUtil from '../../utils/RecordingLocalUtil';

const mapEvent = (event, group_id) => {

    // let ostart =  new Dates(event.date_begin).unix();
    // let oend =  new Dates(event.date_end).unix();
    let ostart =  parseInt(event.unix_begin);
    let oend =  parseInt(event.unix_end);
    let recording_status = 1;

    if(group_id && event.id && event.ext_recordable && event.ext_recordable === '1'){
        // Em caso de que el evento se pueda grabar se actualiza el estatus conforme a la recordingList
        const currentData = RecordingLocalUtil.get(`${group_id}${event.event_alf_id || event.id}`);
        if(currentData && currentData.recording_status){
            recording_status = currentData.recording_status;
        }
    }

    return {
        id: event.id || null,
        event_alf_id: event.event_alf_id || null,
        name: event.name || '',
        date_begin: ostart,
        date_end: oend,
        api_date_begin: event.date_begin,
        api_date_end: event.date_end,
        api_date_begin_unix: event.unix_begin,
        api_date_end_unix: event.unix_end,
        channel_id: event.channel_id || null,
        description: event.description || '',
        duration: event.duration || '',
        dvb_content: event.dvb_content || '',
        ext_catchup: event.ext_catchup || null,
        ext_episode_id: event.ext_episode_id || null,
        ext_eventimage_name: event.ext_eventimage_name || '',
        ext_recordable: event.ext_recordable || null,
        ext_season_id: event.ext_season_id || null,
        ext_series_id: event.ext_series_id || null,
        ext_startover: event.ext_startover || null,
        ext_year: event.ext_year || null,
        group_id: group_id,
        id_composite: `${group_id}${event.event_alf_id || event.id}` || '',
        parental_rating: event.parental_rating || null,
        recording_status: event.ext_recordable === '1' ? recording_status : 0,
        type: event.type || null
      }
}

const mapEvents = (apiResponse, groupIds = []) => {
    const result = [];
    if(!Array.isArray(apiResponse.channels)) return result;
    if(apiResponse.channels.length < EpgConstants.TOTAL_ROWS_CHANNEL_GRID && Array.isArray(groupIds)) {
        const map = groupIds.map (gp => {
            return apiResponse.channels.find((ch) => ch.group_id === gp);    
        })
        apiResponse.channels = map;
    }

    // We use cached length
    const lengthChannels = apiResponse.channels.length || 0;
    const channels = apiResponse.channels.sort((a, b)=>{
        return groupIds.indexOf(a.group_id) - groupIds.indexOf(b.group_id);
    });
    for (let i = 0; i < lengthChannels; i++) {
        let oEvents = [];
        if(Array.isArray(channels[i].events)) {
            const lengthEvents = channels[i].events.length;
            for(let j = 0; j < lengthEvents; j++) {
                oEvents.push(mapEvent(channels[i].events[j], channels[i].group_id));
            }
        }
        result.push(oEvents);
    }

    return result;
};


const EpgChannelApiMapper = {
    mapEvents
};

export default EpgChannelApiMapper;


// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/helpers/EpgChannelApiMapper.js